import {CopyPasteDirective} from '../../CopyPasteDirective'
import {NgModule} from '@angular/core';

@NgModule({
    declarations: [CopyPasteDirective],
    exports: [CopyPasteDirective],
})

export class CopyPasteModule {

}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/lazyloader/CopyPasteModule.ts